{
  "search": "Rechercher",
  "login": "Identifiant",
  "firstname": "Prénom",
  "lastname": "Nom",
  "email": "Email",
  "addUserGroup": "Ajouter un groupe",
  "selectUserProfile": "Sélectionner un profil",
  "profile": "Profil",
  "userProfile": "Profil utilisateur",
  "language": "Langue",
  "label": "Nom",
  "error": {
    "required": "Champ obligatoire",
    "maxLength": "Longueur max: {maxLength}",
    "invalidFormat": "Format non valide",
    "lowercaseOnly": "Minuscules uniquement"
  },
  "url": "URL",
  "deleteFile": "Cliquer pour supprimer le fichier",
  "password": "Mot de passe",
  "nominalTemplateName": "Nom du template nominal",
  "bootstrapTemplateName": "Nom du template bootstrap",
  "secondIntervalTime": "Temps d'intervalle (secondes)",
  "profileName": "Nom du profil",
  "languages": {
    "en": "Anglais (English)",
    "fr": "Français",
    "it": "Italien (Italiano)",
    "es": "Espagnol (Español)",
    "de": "Allemand (Deutsch)"
  },
  "passwordPlaceholder": "**********",
  "clickToUpload": "Cliquer pour importer",
  "orDragAndDrop": "ou glisser-déposer un fichier au format {format}",
  "orDragAndDropWithoutExtension": "\nou glisser-déposer",
  "information": {
    "more": "Voir plus d'informations"
  },
  "select": {
    "search": {
      "placeholder": "Recherche",
      "noResults": "Aucun résultat"
    }
  },
  "timezone": {
    "placeholder": "Choisir le fuseau"
  },
  "selectAll": "Sélectionner tout",
  "optional": "Facultatif"
}
